// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__BE2UA","container":"Modal_container__EY5Qx"};